import { useEffect } from "react";

const VIEWPORT_SCROLLING_CLASS = "viewport-scrolling";
const HIDE_DELAY_MS = 1000;

/**
 * Adds a class to html while the user is scrolling the viewport, removes it after idle.
 * Used with CSS to show scrollbar on scroll and fade it out when idle (macOS-like).
 */
export function useViewportScrollbarVisibility() {
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout> | null = null;

    const show = () => {
      document.documentElement.classList.add(VIEWPORT_SCROLLING_CLASS);
      if (hideTimeout) clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        document.documentElement.classList.remove(VIEWPORT_SCROLLING_CLASS);
        hideTimeout = null;
      }, HIDE_DELAY_MS);
    };

    window.addEventListener("scroll", show, { passive: true });

    return () => {
      window.removeEventListener("scroll", show);
      if (hideTimeout) clearTimeout(hideTimeout);
      document.documentElement.classList.remove(VIEWPORT_SCROLLING_CLASS);
    };
  }, []);
}
